import { render, staticRenderFns } from "./DetallePrecios.vue?vue&type=template&id=1f459e61&scoped=true"
import script from "./DetallePrecios.vue?vue&type=script&lang=js"
export * from "./DetallePrecios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f459e61",
  null
  
)

export default component.exports